// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__23yUq","header":"MergedInvoice_header__2K0Vk"};